module.exports = __webpack_public_path__ + "img/inktober_2020_18_trap.43438688.jpg";